const initImageBanner = () => {
    const imageBannerWidgetList = document.querySelectorAll("[data-image-banner-widget]");
    if (imageBannerWidgetList && imageBannerWidgetList.length > 0) {
        imageBannerWidgetList.forEach((imageBannerWidget) => {
            let isDown = false;
            let startX;
            let scrollLeft;
            imageBannerWidget.addEventListener("mousedown", (e) => {
                isDown = true;
                // the X (horizontal) coordinate (in pixels) at which the mouse was clicked - the number of pixels that the upper left corner of the current element is offset to the left within the HTMLElement.offsetParent node
                startX = e.pageX - imageBannerWidget.offsetLeft;
                // number of pixels that an element's content is scrolled from its left edge
                scrollLeft = imageBannerWidget.scrollLeft;
            });
            imageBannerWidget.addEventListener("mouseleave", (e) => {
                isDown = false;
            });
            imageBannerWidget.addEventListener("mouseup", (e) => {
                isDown = false;
            });
            imageBannerWidget.addEventListener("mousemove", (e) => {
                if (!isDown) {
                    return;
                }
                e.preventDefault();
                const x = e.pageX - imageBannerWidget.offsetLeft;
                //speed of scrolling
                const walk = (x - startX) * 1;
                imageBannerWidget.scrollLeft = scrollLeft - walk;
            });
        });
    }
};
